// extracted by mini-css-extract-plugin
export var statItem = "_il-1";
export var statsRow = "_il-0";